import { POST } from "@/utils/axios";

export function getWxPayInfo(data){
    return POST('/wxPay/createPayInfo', data);
}

export async function checkOrderWxPayStatus(data){
    return await POST('/wxPay/checkOrderPayStatus', data)
}

export function getAliPayInfo(data){
    return POST('/alipay/createPayInfo', data)
}